module.exports = __webpack_public_path__ + "img/emoji.e9ec532.png";